import React, { memo, useMemo } from "react";
import "./styles.scss";

const StatusChip = ({ status }) => {
  const getEllipseColor = useMemo(() => {
    if (
      status === "Not Started" ||
      status === "Medium" ||
      status === "Skipped"
    ) {
      return "#D98634";
    }
    if (status === "Live" || status === "Easy" || status === "Correct") {
      return "#409261";
    }
    if (status === "Completed") {
      return "#3F3748";
    }
    if (status === "Hard" || status === "Incorrect") {
      return "#E25563";
    }
    if (status === "Trail") {
      return "#D98634";
    }

    if (status === "Active") {
      return "#409261";
    }
    if (status === "Inactive") {
      return "#3F3748";
    }
    return "#8B97A8";
  }, [status]);

  const getContainerColor = useMemo(() => {
    if (
      status === "Not Started" ||
      status === "Medium" ||
      status === "Skipped"
    ) {
      return "#FFF2DD";
    }
    if (status === "Live" || status === "Easy" || status === "Correct") {
      return "#E9FFEF";
    }
    if (status === "Completed") {
      return "#E4E4E4";
    }
    if (status === "Hard" || status === "Incorrect") {
      return "#FFE6E9";
    }
    if (status === "Trial") {
      return "#FFF2DD";
    }
    if (status === "Active") {
      return "#E9FFEF";
    }
    if (status === "Inactive") {
      return "#E1E1E1";
    }
    return "#F1F3FA";
  }, [status]);

  return (
    <div>
      <div
        className="chip-container"
        style={{ backgroundColor: `${getContainerColor}` }}
      >
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="5.81569"
            cy="5.30592"
            r="4.86842"
            fill={getEllipseColor}
          />
        </svg>
        <span className="chip-text" style={{ color: `${getEllipseColor}` }}>
          {status}
        </span>
      </div>
    </div>
  );
};

export default memo(StatusChip);
